import React from "react";
import { Outlet } from "react-router-dom";
import { AiDiscoverabilityProvider } from "@stores/AiDiscoverabilityContext";
export const DataProviderLayout = () => (React.createElement(AiDiscoverabilityProvider, null,
    React.createElement(Outlet, null)));
